import request from '@/utils/request' // 复用普通登录认证，只为本功能增加独立凭证。

const prefix = 'pc-experience:' // 本功能存储不与普通考试、教学解锁共用键。

export function experienceDevice() {
  let value = localStorage.getItem(prefix + 'device') // 刷新和重新打开页面沿用当前浏览器身份。
  if (!value) {
    const bytes = new Uint8Array(24) // 不使用会随WebSocket重连改变的client_id。
    window.crypto.getRandomValues(bytes) // 生成随机会话标识。
    value = Array.from(bytes, byte => byte.toString(16).padStart(2, '0')).join('') // 转换为跨平台字符串。
    localStorage.setItem(prefix + 'device', value) // 不保存密码和手机号。
  }
  return value // 服务端会同时检查普通登录和操作令牌。
}

export function operationToken() {
  return localStorage.getItem(prefix + 'operation') || '' // 没有令牌时控制台默认锁定。
}

export function saveOperation(token) {
  if (token) localStorage.setItem(prefix + 'operation', token) // 保存随机操作令牌，24小时由服务端判断。
  else localStorage.removeItem(prefix + 'operation') // 过期/被接管仅删除本功能令牌。
}

export function admissionToken(taskId) {
  return sessionStorage.getItem(prefix + 'admission:' + taskId) || '' // 每场考试独立，刷新仍能恢复。
}

export function saveAdmission(taskId, token) {
  sessionStorage.setItem(prefix + 'admission:' + taskId, token) // 操作令牌失效不会删除学员入场令牌。
}

export function experienceRequest(action, data = {}) {
  const taskId = data.task_id || sessionStorage.getItem(prefix + 'active') || '' // context请求也携带当前场次凭证。
  return request({
    url: '/anqipc/examExperience/' + action, // 新功能独立接口空间。
    method: 'POST', // 验证码和令牌不进入URL。
    silentError: true, // 业务错误在对应界面显示，避免原生alert抢焦点。
    headers: { 'X-Exam-Operation': operationToken(), 'X-Exam-Device': experienceDevice(), 'X-Exam-Admission': admissionToken(taskId) }, // 与原Authorization并存。
    data // 后端不会信任其中的用户归属信息。
  }).then(res => res.data) // 组件只处理本功能数据。
}

export function experienceCacheKey(taskId) {
  return prefix + 'answers:' + taskId // 每场一个答案缓存，不碰原有answer-log。
}
